module.exports = "<div ui-view=\"reporting\"></div>\n";